module.exports = __webpack_public_path__ + "img/w_mockup_frame.ecfa95b1.png";